import { render, staticRenderFns } from "./NewTeamModal.vue?vue&type=template&id=bf96d388&scoped=true"
import script from "./NewTeamModal.vue?vue&type=script&lang=js"
export * from "./NewTeamModal.vue?vue&type=script&lang=js"
import style0 from "./NewTeamModal.vue?vue&type=style&index=0&id=bf96d388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf96d388",
  null
  
)

export default component.exports